import styled from 'styled-components'

export const ToneInstructionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`
